























import { Component, Prop, Model } from 'vue-property-decorator';
import _ from 'lodash';
import { mixins } from 'vue-class-component';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';


@Component
export default class UiSelectItem extends mixins(PlanLimitsMixin) {
  @Model('change')
  modelValue: any

  @Prop()
  color: string

  @Prop({ default: '' })
  helpTooltip: string

  @Prop({ default: true })
  trueValue: any

  @Prop({ default: false })
  falseValue: any

  @Prop({ default: '' })
  label: string;

  @Prop()
  checked: any;

  @Prop({ default: false })
  disabled: boolean;

  get colorState() {
    if (this.disabled || !this.isChecked) return
    return {
      color: this.color || this.$colors.green,
    }
  }

  get isChecked() {
    if (Array.isArray(this.modelValue)) {
      return this.modelValue.includes(this.trueValue)
    }
    return _.isEqual(this.modelValue, this.trueValue)
  }

  handleClick(e){
    if(!this.planLimitsEditable && this.showPlanLimitsIcon){
      e.preventDefault()
      return this.handleClickPlanLimits()
    }

    let modelValue
    // pass v-model as array e.x. [1,2,3] value is 3 result [1,2] or [1,2,3]
    if (Array.isArray(this.modelValue) && this.trueValue) {
      if (this.modelValue.includes(this.trueValue)) {
        modelValue = this.modelValue.filter(item => item !== this.trueValue);
      } else {
        modelValue = [...this.modelValue, this.trueValue];
      }
    } else {
      // in array ['x1',false,'falseValue'] or ['x1',false,'trueValue']
      if (this.isChecked) {
        modelValue = this.falseValue
      } else {
        modelValue = this.trueValue
      }

    }

    this.$emit('change', modelValue);
  }
}
